import React from "react";
import { connect } from "react-redux";
import routes from "../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../common/GridLayout";


import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  MasterDetail,
  Lookup
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const parentDataGrid = React.createRef();
const childDataGrid = React.createRef();
let accessToken = '';
const cellRender = (cellData) => {
  const plusClick = () => {
    parentDataGrid.current.instance().beginCustomLoading("Testing Connection");
    axios.post
    (
      `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.TestDatabaseServerConnection}`,
      cellData.data,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    )
    .then((res) => {
      parentDataGrid.current.instance().endCustomLoading();
      if (res.data.issuccess)
      {
        alert("Test Connection succeeded.", "Success");
      }
      else
      {
        alert("Test Connection failed.", "Error");
      }
    })
    .catch((err) => {
      parentDataGrid.current.instance().endCustomLoading();
      alert(err, "Error");
    });
  };
  return (
    <Button icon="check" onClick={plusClick} style={{backgroundColor:"transparent"}} hint="Test Connection" />
  );
}


// = (data) => <a href="#" class="dx-link dx-link-delete dx-icon-trash dx-link-icon" title="Delete" aria-label="Delete"></a> />;

class UserDatabases extends React.Component {

  constructor(props) {
    super(props);

    this.PasswordEditorOptions = {
        mode: "password"
    };
    this.state = {
      selectedParentItemKeys: []
    };

    accessToken = props.oidc.user.access_token;
    this.parentSelectionChanged = this.parentSelectionChanged.bind(this);
    this.deleteParentRecords = this.deleteParentRecords.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.parentRowInserted = this.parentRowInserted.bind(this);
    this.parentRowUpdated = this.parentRowUpdated.bind(this);
    this.parentRowRemoved = this.parentRowRemoved.bind(this);
    this.parentDataSource = createStore({
      key: 'id',
      loadUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetUserDatabases}`,
      insertUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.InsertUserDatabase}`,
      updateUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.UpdateUserDatabase}`,
      deleteUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.DeleteUserDatabase}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    
  }

  render() {
    return (
      <div className="h-100"  style={{ overflowY: 'hidden' }}>
        <div className="title">
          <h6
            style={{
              color: window._env_.Color2,
              marginLeft: "12px"
            }}
          >
            Facilities
          </h6>
        </div>
       <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={parentDataGrid}
          showBorders={true}
          className="SECURITY_FacilitiesGridStyle"
          selectedRowKeys={this.state.selectedParentItemKeys}
          onSelectionChanged={this.parentSelectionChanged}
          onEditorPreparing={this.editorPreparing}
          onRowInserted={this.parentRowInserted}
          onRowRemoved={this.parentRowRemoved}
          onRowUpdated={this.parentRowUpdated}
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterPanel visible={true} />
          <FilterRow visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={false} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>
          <Editing
            mode="cell"
            newRowPosition="first"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true} />
          <Column dataField="servername" caption="Server Name" editorOptions={{maxLength: 100}}/>
          <Column dataField="username" caption="User Name" editorOptions={{maxLength: 100}}/>
          {/* The API never returns the stored password (it is blanked server-side). Show a fixed
              masked placeholder for saved rows so admins can see a credential is set, without
              leaking the real value or its length. Editing still uses the password-mode editor and
              only sends a new value when the cell is actually changed. */}
          <Column dataField="password" caption="Password" editorOptions={{maxLength: 100}}
            cellRender={(cellData) => (cellData.data && cellData.data.id ? "••••••••" : "")} />
          <Column
            width={45}
            allowFixing={false}
            allowSorting={false}
            allowEditing={false}
            cellRender={cellRender}
            fixed={true} 
            fixedPosition="right" 
          />
          {/* editorOptions={{mode: "password", showClearButton: true}} editorOptions={this.PasswordEditorOptions} */}
          <MasterDetail enabled={true}
            component={UserCompanies}>
          </MasterDetail>
          <Toolbar>
            <Item location="before">
              <div><b>Database Servers</b></div>
            </Item>
            <Item name="addRowButton"/>
            <Item>
              <Button
                onClick={this.deleteParentRecords}
                icon="trash"
                disabled={!this.state.selectedParentItemKeys.length}/>
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton"/>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.parentDataSource);
    }
  }

  deleteParentRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected record(s)?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          parentDataGrid.current.instance().beginCustomLoading("Deleting");
          axios.post
          (
            `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.DeleteUserDatabases}`,
            that.state.selectedParentItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            parentDataGrid.current.instance().endCustomLoading();
            if (res.data.issuccess)
            {
              parentDataGrid.current.instance().refresh();
              alert("Record(s) deleted but IIS must be restarted for the changes to take effect.", "Success");
            }
            else
            {
              alert(res.data.errormessage, "Error");
            }
          })
          .catch((err) => {
            parentDataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }

  parentSelectionChanged(data) {
    this.setState({
      selectedParentItemKeys: data.selectedRowKeys,
    });
  }

  editorPreparing(e) {
    if (e.parentType == 'dataRow' && e.dataField == "password") 
    {  
      e.editorOptions.mode = "password";
      e.editorOptions.inputAttr = { autocomplete: 'new-password' };
    }  
  }

  parentRowInserted(e) {
    alert("Record saved but IIS must be restarted for the changes to take effect.", "Success");
  }

  parentRowUpdated(e) {
    alert("Record updated but IIS must be restarted for the changes to take effect.", "Success");
  }

  parentRowRemoved(e) {
    alert("Record deleted but IIS must be restarted for the changes to take effect.", "Success");
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

class UserCompanies extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      userDatabaseId : props.data.key,
      selectedChildItemKeys: [],
    };

    this.childSelectionChanged = this.childSelectionChanged.bind(this);
    this.deleteChildRecords = this.deleteChildRecords.bind(this);
    this.childRowInserting = this.childRowInserting.bind(this);
    this.childRowInserted = this.childRowInserted.bind(this);
    this.childRowUpdated = this.childRowUpdated.bind(this);
    this.childRowRemoved = this.childRowRemoved.bind(this);
    this.childDataSource = createStore({
      key: 'id',
      loadParams: { userDatabaseId: this.state.userDatabaseId },
      loadUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetUserCompanies}`,
      insertUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.InsertUserCompany}`,
      updateUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.UpdateUserCompany}`,
      deleteUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.DeleteUserCompany}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
    this.DatabaseDataSource = createStore({
      key: "databaseName",
      loadUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabaseAliases}`,
      onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
              Authorization: `Bearer ${accessToken}`
          };
      }
  });
  }

  render() {
    return (
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
        ref={childDataGrid}
        dataSource={this.childDataSource}
        showBorders={true}
        selectedRowKeys={this.state.selectedChildItemKeys}
        onSelectionChanged={this.childSelectionChanged}
        onRowInserting={this.childRowInserting}
        onRowInserted={this.childRowInserted}
        onRowUpdated={this.childRowUpdated}
        onRowRemoved={this.childRowRemoved}
        rowAlternationEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        columnAutoWidth={true}
      >
        <Selection mode="multiple" />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <FilterBuilderPopup position={filterBuilderPopupPosition} />
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <HeaderFilter visible={false} />
        <ColumnFixing enabled={true}/>,
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting mode="multiple"/>
        <Editing
          mode="cell"
          newRowPosition="first"
          refreshMode="repaint"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true} />
        <Column dataField="name" caption="Name" editorOptions={{maxLength: 255}}/>
        <Column dataField="company" caption="Company" editorOptions={{maxLength: 2}}/>
        <Column dataField="databaseName" caption="Database Name">
          <Lookup
            displayExpr="aliasName"
            valueExpr="databaseName"
            dataSource={this.DatabaseDataSource} />
        </Column>
        {/* <Column dataField="datatype" caption="Data Type">
          
        </Column> */}
        <Toolbar>
          <Item location="before">
            <div><b>Companies</b></div>
          </Item>
          <Item name="addRowButton"/>
          <Item>
            <Button
              onClick={this.deleteChildRecords}
              icon="trash"
              disabled={!this.state.selectedChildItemKeys.length}/>
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton"/>
        </Toolbar>
      </DataGrid>
    );
  }

  
  deleteChildRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          childDataGrid.current.instance().beginCustomLoading("Deleting");
          axios.post
          (
            `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.DeleteUserCompanies}`,
            that.state.selectedChildItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            childDataGrid.current.instance().endCustomLoading();
            if (res.data.issuccess)
            {
              childDataGrid.current.instance().refresh();
              alert("Record(s) deleted but IIS must be restarted for the changes to take effect.", "Success");
            }
            else
            {
              alert(res.data.errormessage, "Error");
            }
          })
          .catch((err) => {
            childDataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }

  childSelectionChanged(data) {
    this.setState({
      selectedChildItemKeys: data.selectedRowKeys,
    });
  }

  childRowInserting(e) {
    e.data['userDatabaseId'] = this.state.userDatabaseId;
  }

  childRowInserted(e) {
    alert("Record saved but IIS must be restarted for the changes to take effect.<br/>To make this Facility visible to the current user after restarting IIS, go the User Security screen under the Security menu and then edit that current user. <br/>Select the newly added Facility and then click on save button. Logout and then Login again.", "Success");
  }

  childRowUpdated(e) {
    alert("Record updated but IIS must be restarted for the changes to take effect.", "Success");
  }

  childRowRemoved(e) {
    alert("Record deleted but IIS must be restarted for the changes to take effect.", "Success");
  }

}

connect(mapStateToProps)(UserCompanies);
export default connect(mapStateToProps)(UserDatabases);

